import { gql } from '@src/lib/gql'

export const ADVISOR_PAYOUTS = gql`
  query AdvisorPayouts($pageSize: Int, $page: Int) {
    advisorPayouts(pageSize: $pageSize, page: $page) {
      items {
        id
        advisorPayoutId
        userId
        amountUsd
        statusKey
        status {
          id
          key
          title
        }
        stripeTransferId
        stripeConnectAccountId
        failureReason
        requestedAt
        completedAt
        failedAt
        createdAt
      }
      pagination {
        itemCount
        hasNextPage
        page
        pageSize
        pageCount
      }
    }
  }
`
